// Formato de números/moneda estilo Paraguay (guaraníes sin decimales; resto 2 decimales).

export function esGuaranies(moneda) {
  const cod = (moneda?.codigo || '').toLowerCase()
  return cod === 'guaranies' || cod === 'gs' || cod === 'pyg'
}

export function decimalsForMoneda(moneda) {
  return esGuaranies(moneda) ? 0 : 2
}

export function formatNumber(value, decimals = 0) {
  const n = Number(value) || 0
  return n.toLocaleString('es-PY', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export function formatCurrency(value, moneda) {
  const dec = decimalsForMoneda(moneda)
  const simbolo = esGuaranies(moneda) ? '₲' : moneda?.simbolo || ''
  return `${simbolo ? simbolo + ' ' : ''}${formatNumber(value, dec)}`
}

export function parseNumber(input) {
  if (input == null || input === '') return 0
  if (typeof input === 'number') return input
  // admite "1.234,56" o "1234.56"
  const s = String(input).replace(/\./g, '').replace(',', '.')
  const n = parseFloat(s)
  return isNaN(n) ? 0 : n
}
